export const UNSET = 'UNSET'
export const LOADING = 'LOADING'
export const LOADED = 'LOADED'
export const ERROR = 'ERROR'

export type ReduxStateStatus = typeof ERROR | typeof LOADED | typeof LOADING | typeof UNSET
